import * as Sentry from '@sentry/react';
import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import {
  isDev,
  isJestRuntime,
  isTestRuntime,
  sellerApiUrl,
  sentryDsn,
  sentryEnvironment,
} from 'shared/constants/envVariables';

const sentryEnabled = Boolean(sentryDsn) && !isJestRuntime && !isTestRuntime;

const sellerApiOrigin = (() => {
  if (!sellerApiUrl) {
    return undefined;
  }
  try {
    return new URL(sellerApiUrl).origin;
  } catch {
    return undefined;
  }
})();

if (sentryEnabled) {
  Sentry.init({
    dsn: sentryDsn,
    environment: sentryEnvironment,
    integrations: [
      Sentry.reactRouterBrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate:
      sentryEnvironment === 'production' || (!sentryEnvironment && !isDev)
        ? 0.2
        : 1.0,
    tracePropagationTargets: [
      'localhost',
      ...(sellerApiOrigin ? [sellerApiOrigin] : []),
      /^https:\/\/api\./,
    ],
  });
}
